import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { T2TemplateBasicComponent } from '../../trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { TrackerComponent } from './components/tracker/tracker.component';

const routes: Routes = [
  { path: 'pages', component: T2TemplateBasicComponent,
  children: [
    { path: 'dispatch',
      children: [
        { path: 'tracker', component: TrackerComponent, data: { title: 'Tracker'} }
      ]
    }
  ]
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class TrackerRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/tracker/tracker-routing.module.ts